import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable()
export class LoadingService {
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  active: boolean = false;

  constructor() { }

  public set(state: boolean) {
    this.active = state;
    this.onChange.emit(state);
  }

}
